import React from 'react';
import styled from 'styled-components';
import GlobalStyle from '../../../GlobalStyle';
import { createGlobalStyle } from 'styled-components';
import { Link } from 'react-router-dom';

const Btn = styled.button`
  border-radius: 27px;
  background-color: #27ce0a;
  color: #ffffff;
  font-size: 16px;
  font-weight: 700;
  padding: 9px 22px;
  line-height: 1.2;
  border: solid 1px #27ce0a;
  font-family: 'helveticaneuebold';
  transition: 0.3s;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    font-size: 12px;
    padding: 6px 12px;
    border-radius: 16px;
    font-family: 'helvetica_neuemedium_extended';
    font-weight: normal;
  }
  &:active,
  &:focus {
    box-shadow: 0 0 0 0.2rem rgb(40 167 69 / 50%);
  }
  &.outline {
    background-color: #ffffff;
    color: #27ce0a;
    &:active,
    &:focus,
    &:hover {
      background-color: #27ce0a;
      color: #ffffff;
    }
  }
  &:disabled {
    cursor: default;
    pointer-events: none;
    opacity: 0.5;
  }
`;

const SmallButton = (props) => {
  return (
    <>
      <GlobalStyle />

      <Btn
        {...props}
        id={props.id}
        className={`${props.outline}`}
        // onClick={props.onClick}
        title=""
      >
        {props.title}
      </Btn>
    </>
  );
};

export default SmallButton;
